<div class="vcard-for-wizzard" [ngClass]="{'-no-left': !imageSrc && !loading, '-side-paddings': sidePaddings}">
    <div class="vcard-for-wizzard__inner" directive-collapse [collapsed]="collapsed">

        <div class="vcard-for-wizzard__col -left">
            <div class="vcard-for-wizzard__thumb">
                <shared-square-image [icon]="icon" (onLoaded)="handleImageLoaded($event)" [src]="imageSrc"
                    [loading]="loading" [invisible]="loading" [alt]="title" class="vcard-for-wizzard__img">
                </shared-square-image>
            </div>
        </div>

        <div class="vcard-for-wizzard__col -right">
            <shared-header class="vcard-for-wizzard__hd" [loading]="loading" [ellipsis]="ellipsis" [type]="headerType"
                marginTop="none" marginBottom="xs">{{title}}</shared-header>

            <div class="vcard-for-wizzard__desc" *ngIf="description && !loading">
                {{description}}
            </div>

            <div class="vcard-for-wizzard__content" [hidden]="!hasContent" #content>
                <ng-content></ng-content>
            </div>

            <div class="vcard-for-wizzard__ft" *ngIf="!loading">
                <shared-stats class="vcard-for-wizzard__stats" [stats]="stats" *ngIf="stats"></shared-stats>

                <shared-tag-images class="vcard-for-wizzard__tag-images" [images]="tagImages"
                    *ngIf="tagImages && tagImages.length > 0">
                </shared-tag-images>
            </div>




            <shared-loader-for-placeholder *ngIf="loading" class="vcard-for-wizzard__loader -for-description">
            </shared-loader-for-placeholder>

            <shared-loader-for-placeholder *ngIf="loading" class="vcard-for-wizzard__loader -for-footer">
            </shared-loader-for-placeholder>
        </div>

    </div>
</div>
